export default "__VITE_ASSET__BKtLoBXd__"